







import { Component, Prop, Vue } from 'vue-property-decorator';
import { Location } from 'vue-router';
import Study from '@/study/Study';

@Component
export default class SearchResultItem extends Vue {
    @Prop({ required: true })
    study!: Study;

    private get locationUrl(): Location {
        return {
            name: 'location',
            params: {
                locale: this.$route.params.locale,
                location: this.study.location.id,
            },
        };
    }
}
